import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const availableSliderControllers = [];

export default class extends Controller {
    connect() {
        availableSliderControllers.push(this);
        const element = this.element;
        const additionalConfig = element.dataset.splide ? JSON.parse(element.dataset.splide) : {};

        // Config https://splidejs.com/guides/options/
        const config = {
            autoWidth: true,
            speed: 1000,
            autoplay: false,
            gap: '20px',
            ...additionalConfig,
        };

        this.splide = new Splide(element, config);

        if (element.dataset.sync) {
            for (const controller of availableSliderControllers) {
                if (controller.element.id === element.dataset.sync) {
                    this.splide.sync(controller.splide);
                }
            }
        }

        if (element.dataset.autoscroll) {
            this.splide.mount( { AutoScroll } );
        } else {
            this.splide.mount();
        }

        if (element.dataset.slidecount) {
            const observer = new MutationObserver(() => {
                this.slidesVisibleCount();
            });
            observer.observe(element.querySelector('.thumbnails .splide__slide'), {
                subtree: false,
                attributes: true,
            });
            this.slidesVisibleCount();
        }
    }

    slidesVisibleCount() {
        const more = this.element.querySelector(".thumbnail-more");
        if ( !more ) {
            return;
        }
        let invisibleSlides = 0;
        let startCount = false;
        this.element.querySelectorAll(".thumbnails .thumbnail").forEach(function(elm) {
            if (elm.classList.contains("is-visible")) {
                startCount = true;
            } else if (startCount) {
                invisibleSlides++;
            }
        });
        more.querySelector("span").innerHTML = "+" + invisibleSlides;
        if (invisibleSlides === 0) {
            more.style.display = "none";
        } else {
            more.style.display = "block";
        }
    }

    static refreshSliders() {
        for (const controller of availableSliderControllers) {
            controller.splide.destroy();
            controller.splide.mount();
        }
    }
}
